<template>
  <ViewEmailSetting :configKey="configKey" />
</template>


<script>
import ViewEmailSetting from '@/views/admin/settings/email/ViewEmailSetting.vue';

export default {
    name: 'PartnerEmailSettings',
    props: {},
    components: {
        ViewEmailSetting
    },

    data() {
        return {
        }
    },

    methods: {},

    computed: {
        configKey: () => 'PartnerAppointmentInformationEmail',
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>